module.exports = __webpack_public_path__ + "static/img/sand_15_max_2.7ac5132e.png";